export default "__VITE_ASSET__BhbWlQML__"